<template>
  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    :aria-labelledby="$t('adm.page.settings.title')"
    ref="offcanvas">

    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="ocTitle">{{ $t('adm.page.settings.title') }}</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
    </div>

    <div class="offcanvas-body">

      <div id="sectNotification" class="mt-5">

        <div>{{ $t('adm.page.settings.noteWantToBeNotified') }}</div>
        <div class="form-check form-switch mt-3">
          <input class="form-check-input mt-0" type="checkbox" role="switch" id="switchNotify" v-model="notification">
          <label class="form-check-label ms-2" for="switchNotify">
            {{ $t('adm.page.settings.notificationSwitch') }}
          </label>
        </div>

        <div class="modal-footer mt-3">
          <button type="button" class="btn btn-primary" @click="save" :disabled="state !== 'ready'">
            {{ $t('adm.button.save') }}
          </button>
        </div>

        <the-overlay :active="state === 'loading'" :showSpinner="true" />

      </div>

    </div>

  </div>
</template>

<script lang="ts">

import { Offcanvas } from 'bootstrap';
import { defineComponent } from 'vue';
import Backend from '@/components/backend';
import TheOverlay from '../ui/TheOverlay.vue';

export default defineComponent({
  name: 'UserPreferences',
  components: { TheOverlay },
  data() {
    return {
      notification: false,
      state: 'null',
    };
  },
  methods: {
    save() {
      // console.info(`[UserPreferences] saving`)
      this.state = 'loading';
      Backend.validateToken().then((api) => api
        .saveMyPreferences({
          ddcNotification: this.notification,
        })
        .then(() => {
          // console.info(`[UserPreferences] saved`)
          this.$toast.success(this.$t('adm.page.settings.saved'));
          this.offcanvas.hide();
          this.state = 'ready';
        })
        .catch(() => {
          this.$toast.error(this.$t('adm.page.settings.saveError'));
          this.state = 'ready';
        }));
    },
    load() {
      // console.info(`[UserPreferences] loading`)
      this.state = 'loading';

      Backend.validateToken().then((api) => api.getMyPreferences()
        .then((r) => {
          // console.info(`[UserPreferences] loaded`)
          this.notification = r.ddcNotification ?? false;
          this.state = 'ready';
        })
        .catch(() => {
          this.$toast.error(this.$t('adm.page.settings.loadError'));
          this.state = 'error';
        }));
    },
  },
  computed: {
    offcanvas() {
      return Offcanvas.getOrCreateInstance(this.$refs.offcanvas as HTMLElement);
    },
  },
  mounted() {
    const elem = this.$refs.offcanvas as HTMLElement;
    elem.addEventListener('show.bs.offcanvas', this.load);
  },
});
</script>

<style>

.offcanvas{
padding: 1rem;
}

.offcanvas-title {
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: var(--stihl-font-family-text);
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

</style>
